import { Link } from "react-router-dom";

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`text-xs sm:text-sm font-extrabold uppercase tracking-[0.25em] text-tpink ${className}`}>{children}</p>
);

export const SectionHead = ({ eyebrow, title, action, to, light }) => (
  <div className="flex items-end justify-between gap-6 mb-8 sm:mb-10">
    <div>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className={`mt-2 text-3xl sm:text-5xl font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}>{title}</h2>
    </div>
    {action && (
      <Link to={to} className={`hidden sm:inline-flex shrink-0 rounded-full border-2 px-5 py-2.5 font-bold transition-colors ${light ? "border-white text-white hover:bg-white hover:text-navy" : "border-navy text-navy hover:bg-navy hover:text-white"}`} data-testid={`section-action-${to.split("/").pop()}`}>
        {action}
      </Link>
    )}
  </div>
);

export const PageHero = ({ eyebrow, title, subtitle, image, children }) => (
  <section className="relative z-20 bg-navy grain" data-testid="page-hero">
    <div className="absolute inset-0 overflow-hidden">
      {image ? <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60 animate-kenburns" /> : <div className="absolute inset-0 ocean-gradient" />}
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/70 to-navy/10" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      {eyebrow && <Eyebrow className="!text-sun">{eyebrow}</Eyebrow>}
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white max-w-3xl animate-rise" data-testid="page-title">{title}</h1>
      {subtitle && <p className="font-brush text-2xl sm:text-4xl text-sun mt-3 animate-rise [animation-delay:120ms]" data-testid="page-subtitle">{subtitle}</p>}
      {children}
    </div>
  </section>
);

export const EmptyState = ({ title, text, children, testid = "empty-state" }) => (
  <div className="rounded-[32px] bg-sand border-2 border-dashed border-sunset/30 px-6 py-14 sm:p-16 text-center" data-testid={testid}>
    <p className="font-brush text-4xl sm:text-5xl text-navy">{title}</p>
    {text && <p className="mt-3 text-navy/70 max-w-xl mx-auto">{text}</p>}
    {children && <div className="mt-8">{children}</div>}
  </div>
);

export const Crumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="text-sm text-navy/60 mb-6" data-testid="breadcrumbs">
    {items.map(([label, to], i) => (
      <span key={label}>
        {i > 0 && <span className="mx-2">/</span>}
        {to ? <Link to={to} className="hover:text-navy">{label}</Link> : <span className="text-navy font-medium">{label}</span>}
      </span>
    ))}
  </nav>
);
